/* global axios */
import ApiClient from './ApiClient';

class CustomSlaPoliciesAPI extends ApiClient {
  constructor() {
    super('custom_sla_policies', { accountScoped: true });
  }

  getReport(policyId, days = 30, agentId = null) {
    const params = { days };
    if (agentId) params.agent_id = agentId;
    return axios.get(`${this.url}/${policyId}/report`, { params });
  }
}

export default new CustomSlaPoliciesAPI();
